import {
  SET_VISIT_TYPE_LIST,
  SET_VISIT_TIME_LIST,
  SET_INSTITUTION,
  SET_BOOK_RESULT,
  RESET_APPOINTMENT_STATE,
  VISIT_TYPE_LIST_KEY,
  INSTITUTION_KEY,
  VISIT_TIME_LIST_KEY,
  BOOK_RESULT_KEY,
} from '../../types/appointment.types'
import initialState from './state'

export default {
  [SET_VISIT_TYPE_LIST]: (state, payload) => {
    state[VISIT_TYPE_LIST_KEY] = payload
  },
  [SET_INSTITUTION]: (state, payload) => {
    const smartpetClinic = payload.reverse().find(institution => institution.name.toUpperCase().indexOf('SMARTPET') > -1)
    state[INSTITUTION_KEY] = smartpetClinic
  },
  [SET_VISIT_TIME_LIST]: (state, payload) => {
    const timeRanges = payload.length > 0 ? payload[0].timeIntervals : []
    state[VISIT_TIME_LIST_KEY] = timeRanges
  },
  [SET_BOOK_RESULT]: (state, payload) => {
    const isError = payload.status === 'error'
    state[BOOK_RESULT_KEY] = !isError
  },
  [RESET_APPOINTMENT_STATE]: (state) => {
    Object.assign(state, initialState())
  },
}
